import React from 'react';
import { ReservationDetails } from 'Molecules/';
import { Header, SubFooter } from 'Atoms/';

export default function reservationDetails() {
  return (
    <div>
      <Header
        classType="header-int"
        title1="ʻĪao Valley"
        title2="State Monument"
        url="iao-valley"
      />
      <ReservationDetails park="63edc307c8f7df7ca39389d0" url="iao-valley" />
      <SubFooter name="ʻĪao Valley State Monument" url="iao-valley" />
    </div>
  );
}
